<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">
            E-mails Newsletter
            <span>
              <a style="margin-left: 15px" class="btn btn-primary" type="submit" data-toggle="modal" data-target="#add-modal">Novo e-mail</a>
            </span>
          </h1>
        </div>
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/newsletter">Newsletter</a></li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <!-- FILTROS -->
  <div class="card">
    <div class="card-header">
      <h5 class="card-title">Filtrar e-mails</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-3">
          <div class="form-group">
            <label for="nome">E-mail</label>
            <input class="form-control" id="id" v-model="email" />
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <button type="button" class="btn btn-primary" @click="buscar()">Buscar</button>

            <button type="button" class="btn btn-default" @click="limparFiltros" style="margin-left: 15px">Limpar filtros</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <!-- TABELA DE registros -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Emails</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Id</th>
              <th>Email</th>
              <th>Apelido</th>
              <th>Tipo</th>
              <th>Criado em</th>
              <th>Verificado em</th>
              <th style="text-align: center">
                Interações
                <br />
                (old)
              </th>
              <th>Aberturas</th>
              <th>Cliques</th>
              <th>Reporte SPAM</th>
              <th>Deletado em</th>
              <th>Listas</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(email, index) in newsletter_emails" :key="email">
              <td>{{ index + 1 }}</td>
              <td>{{ email.id }}</td>
              <td>{{ email.email }}</td>
              <td>{{ email.apelido }}</td>
              <td>
                <span class="right badge badge-danger" style="margin-left: 15px; background-color: #301904" v-if="email.cadastro_tipo == 'pj'">
                  PJ
                </span>
                <span class="right badge badge-danger" style="margin-left: 15px; background-color: blue" v-if="email.cadastro_tipo == 'pf'">PF</span>
              </td>
              <td>{{ formatDate(email.created_at) }}</td>
              <td>
                <!--
                  <span class="right badge badge-danger" style="margin-left: 15px; background-color: green" v-if="email.verificado == 1">Sim</span>
                  <span class="right badge badge-danger" style="margin-left: 15px; background-color: red" v-else>Não</span>
                  -->

                <!-- <span v-if="email.verified_at">{{ formatDate(email.verified_at) }}</span> -->

                <a v-if="email.verified_at" href="#" data-toggle="modal" data-target="#info-modal-verificado" @click="email_info_selecionado = email">
                  {{ formatDate(email.verified_at) }}
                </a>

                <!--
                  <button
                    v-if="email.verified_at"
                    data-toggle="modal"
                    data-target="#info-modal-verificado"
                    @click="email_info_selecionado = email"
                    type="button"
                    class="btn btn-default btn-sm"
                    style="border-radius: 50%; margin-left: 2px; font-size: 8px"
                  >
                    Detalhes
                  </button>
                  -->
              </td>
              <td style="text-align: center">{{ email.interacoes }}</td>

              <td style="text-align: center">0</td>
              <td style="text-align: center">0</td>
              <td style="text-align: center">0</td>
              <td>
                <a v-if="email.deleted_at" href="#" data-toggle="modal" data-target="#info-modal" @click="email_info_selecionado = email">
                  {{ formatDate(email.deleted_at) }}
                </a>

                <!--
                  <span v-if="email.deleted_at">{{ formatDate(email.deleted_at) }}</span>
                  
                  <button
                    v-if="email.deleted_by"
                    data-toggle="modal"
                    data-target="#info-modal"
                    @click="email_info_selecionado = email"
                    type="button"
                    class="btn btn-default btn-sm"
                    style="border-radius: 50%; margin-left: 2px; font-size: 8px"
                  >
                    Detalhes
                  </button>
                  -->
              </td>
              <td>
                <!--
                  <span
                    v-for="(lista, index) in email.listas"
                    :key="lista"
                    class="right badge badge-danger"
                    style="cursor: pointer; margin-left: 2px; background-color: #301904"
                    data-toggle="modal"
                    data-target="#lista-modal"
                    @click="lista_selecionada = lista"
                  >
                    {{ lista.id }}
                  </span>
                  -->
                <div v-for="(lista, index) in email.listas" :key="lista">
                  <span class="right badge badge-danger" style="margin-left: 15px; background-color: #301904">
                    {{ lista.nome }}
                  </span>
                </div>
              </td>
              <td data-label="Ações">
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <!--
                    <a class="dropdown-item" data-toggle="modal" data-target="#detalhes-modal" @click="email_selecionado = email">
                      <i class="fa-solid fa-search"></i>
                      &nbsp;&nbsp; Detalhes
                    </a>
                    -->

                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" @click="excluir(email)">
                    <i class="fa-solid fa-trash"></i>
                    &nbsp;&nbsp; Deletar
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- EXIBIR DETALHES -->
      <div class="modal fade" id="lista-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="card-body table-responsive p-0"></div>

              <h2>Lista id: {{ lista_selecionada.id }}</h2>
              <h2>Nome: {{ lista_selecionada.nome }}</h2>

              <button @click="exibir_detalhes = false" data-toggle="modal" data-target="#lista-modal" class="btn btn-danger btn-sm">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <!-- EXIBIR DETALHES -->
      <div
        class="modal fade"
        @click.self="exibir_detalhes = false"
        @keydown.esc="exibir_detalhes = false"
        id="detalhes-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="imageModal"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body" v-if="email_selecionado">
              <div class="card-body table-responsive p-0"></div>

              <!--
                <div class="row">
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="description" style="width: 100%">E-mail</label>
                      <div class="input-group mb-3">
                        <input disabled class="form-control" v-model="email_selecionado.email" />
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="description" style="width: 100%">Criado em</label>
                      <div class="input-group mb-3">
                        <input disabled class="form-control" :value="formatDate(email_selecionado.created_at)" />
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="description" style="width: 100%">Verificado</label>
                      <div class="input-group mb-3">
                        <input disabled class="form-control" v-if="email_selecionado.verificado == 1" value="Sim" />
                        <input disabled class="form-control" v-else value="Não" />
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="description" style="width: 100%">Tipo</label>
                      <div class="input-group mb-3">
                        <input disabled class="form-control" v-model="email_selecionado.cadastro_tipo" style="text-transform: uppercase" />
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="description" style="width: 100%">Interações</label>
                      <div class="input-group mb-3">
                        <input disabled class="form-control" v-model="email_selecionado.interacoes" />
                      </div>
                    </div>
                  </div>
                </div>
-->

              <table class="table table-hover text-nowrap">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Email</th>
                    <th>Criado em</th>
                    <th>Tipo</th>
                    <th>Criado em</th>
                    <th>Verificado</th>
                    <th>Interações</th>
                    <th>Deletado</th>
                    <th>Deletado em</th>
                    <th>Deletado por</th>
                    <th>Listas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ email_selecionado.id }}</td>
                    <td>{{ email_selecionado.email }}</td>
                    <td>{{ formatDate(email_selecionado.created_at) }}</td>
                    <td>
                      <span
                        class="right badge badge-danger"
                        style="margin-left: 15px; background-color: #301904"
                        v-if="email_selecionado.cadastro_tipo == 'pj'"
                      >
                        PJ
                      </span>
                      <span
                        class="right badge badge-danger"
                        style="margin-left: 15px; background-color: blue"
                        v-if="email_selecionado.cadastro_tipo == 'pf'"
                      >
                        PF
                      </span>
                    </td>
                    <td>{{ formatDate(email_selecionado.created_at) }}</td>
                    <td>
                      <span
                        class="right badge badge-danger"
                        style="margin-left: 15px; background-color: green"
                        v-if="email_selecionado.verificado == 1"
                      >
                        Sim
                      </span>
                      <span class="right badge badge-danger" style="margin-left: 15px; background-color: red" v-else>Não</span>
                    </td>
                    <td>{{ email_selecionado.interacoes }}</td>
                    <td>
                      <span class="right badge badge-danger" style="margin-left: 15px; background-color: red" v-if="email_selecionado.deleted_at">
                        Sim
                      </span>
                      <span class="right badge badge-danger" style="margin-left: 15px; background-color: green" v-else>Não</span>
                    </td>
                    <td>
                      <span v-if="email_selecionado.deleted_at">{{ formatDate(email_selecionado.deleted_at) }}</span>
                    </td>
                    <td>
                      {{ email_selecionado.deleted_by }}
                    </td>
                    <td>
                      <div v-for="(lista, index) in email_selecionado.listas" :key="lista">
                        <span class="right badge badge-danger" style="margin-left: 15px; background-color: #301904">
                          {{ lista.nome }}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <button @click="exibir_detalhes = false" data-toggle="modal" data-target="#detalhes-modal" class="btn btn-danger btn-sm">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + newsletter_emails.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="1">1</option>
          <option :value="2">2</option>
          <option :value="7">7</option>
          <option :value="15">15</option>
          <option :value="25">25</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>
  </div>

  <!-- ADICIONAR NOVO -->
  <div class="modal fade" id="add-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
            <div class="form-group">
              <label>E-mail</label>
              <input class="form-control" v-model="email_add" />
            </div>

            <div class="form-group">
              <label>Motivo</label>
              <textarea rows="4" cols="50" style="width: 100%" v-model="motivo" class="form-control"></textarea>
            </div>

            <button @click="adicionarNovo" type="submit" class="btn btn-success">Adicionar</button>

            <button id="close_add" style="margin-left: 15px" type="submit" class="btn btn-primary" data-dismiss="modal">Cancelar</button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL DELETADO POR-->
  <div class="modal fade" id="info-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" style="vertical-align: center">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
          <h2>Detalhes da exclusão</h2>
          <div>
            <span style="font-weight: bold">Id:</span>
            {{ email_info_selecionado.id }}
            <br />
            <span style="font-weight: bold">Email:</span>
            {{ email_info_selecionado.email }}
            <br />
            <span style="font-weight: bold">Deletado em:</span>
            {{ formatDate(email_info_selecionado.deleted_at) }}
            <br />
            <span style="font-weight: bold">Deletado por:</span>
            {{ email_info_selecionado.deleted_by }}
            <br />
            <span style="font-weight: bold">Motivo:</span>
            {{ email_info_selecionado.deleted_reason }}
          </div>

          <br />
          <br />
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            data-target="#info-modal"
            style="color: black; font-size: 15px; color: white"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL VALIDADO POR-->
  <div class="modal fade" id="info-modal-verificado" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" style="vertical-align: center">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
          <h2>Detalhes da verificação</h2>
          <div>
            <span style="font-weight: bold">Id:</span>
            {{ email_info_selecionado.id }}
            <br />
            <span style="font-weight: bold">Email:</span>
            {{ email_info_selecionado.email }}
            <br />
            <span style="font-weight: bold">Verificado em:</span>
            {{ formatDate(email_info_selecionado.verified_at) }}
            <br />
            <span style="font-weight: bold">Motivo:</span>
            {{ email_info_selecionado.verified_reason }}
          </div>

          <br />
          <br />
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            data-target="#info-modal-verificado"
            style="color: black; font-size: 15px; color: white"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: [],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      registro_selecionado: "",
      filtro: "",
      paginas: [],
      registros: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome_contato: "",
      max_page: 0,
      editar_registro: false,
      cadastrar_registro: false,
      newsletter_emails: [],
      email_selecionada: "",
      exibir_detalhes: false,
      cadastrar_email: false,
      email: "",
      email_info_selecionado: "",
      email_selecionado: "",
      lista_selecionada: "",
      email_add: "",
      motivo: "",
    };
  },

  mounted() {
    console.log(this.registros);

    this.buscar();
  },

  methods: {
    adicionarNovo() {
      this.isLoading = true;

      let data = {
        email: this.email_add,
        motivo: this.motivo,
      };

      console.log("URL =");
      console.log(data);

      axios
        .post("/admin/newsletter_emails/add", data)
        .then((response) => {
          if (response.data.success) {
            this.isLoading = false;

            this.showSuccessMessageWithButton("Sucesso!", response.data.msg);

            let btn = document.getElementById("close_add");
            btn.click();

            this.buscar();
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    excluir(email_selecionado) {
      let html = "Deseja apagar o e-mail <b>" + email_selecionado.email + "</b>? Essa ação é irreversível.";
      html = html + '<br/><br/><label for="rejeicao" style="margin-bottom: -20px;">Motivo da exclusão:</label>';

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          padding: "1.5em",
          input: "textarea",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero excluir!",
          focusConfirm: false,
          preConfirm: (value) => {
            if (!value) {
              this.$swal.showValidationMessage('<i class="fa fa-info-circle"></i> O motivo é obrigatório.');
            }
          },
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: email_selecionado.id,
              deleted_reason: result.value,
            };

            console.log("Deletando");
            console.log(data);

            axios
              .post(`/admin/newsletter_emails/delete`, data)
              .then((response) => {
                if (response.data.success) {
                  this.showSuccessMessage("E-mail deletado com sucesso!");
                } else {
                  this.showErrorMessageWithButton("Ops...", response.data.msg);
                }
                this.buscar();
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    acaoRealizada(acao) {
      if (acao == "editar") {
        this.cadastrar_email = false;
        this.buscar();
      }

      if (acao == "cadastrar") {
        this.cadastrar_email = false;
        this.buscar();
      }
    },

    closeModal() {
      this.editar_blockname = false;
      this.cadastrar_blockname = false;
    },

    selecionarLista(email) {
      this.email_selecionada = email;
      this.exibir_detalhes = true;

      this.$nextTick(function () {
        let btn = document.getElementById("show_modal");
        btn.click();
      });
    },

    buscar() {
      this.isLoading = true;

      let data = {
        email: this.email,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("URL =");
      console.log(data);

      axios
        .post("/admin/newsletter_emails/search", data)
        .then((response) => {
          this.newsletter_emails = response.data.newsletter_emails;
          this.total = response.data.total;

          console.log("RESPOSTA");
          console.log(response.data);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    limparFiltros() {
      this.email = null;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscar();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscar();
      }
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);
      console.log("Max = " + this.max_page);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarRegistros();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1500px;
  margin-left: -430px;
}

@media screen and (max-width: 1600px) {
  .modal-content {
    width: 1350px;
    margin-left: -400px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1350px) {
  .modal-content {
    width: 1250px;
    margin-left: -350px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1100px;
    margin-left: -280px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 1000px;
    margin-left: -240px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
    min-width: 400px;
  }
}
</style>
